/* NetBoxPlatformsEditor.js */

"use strict";

/**
 * @type {uiCoreTools}
 */
const _ = require("lodash");
const uiCore = require("@gluenetworks/steve_ui_core");
const CommonEditor = require("../CommonEditor");

const SingleComboBoxControl = uiCore.Control.OptionSelection.Single.ComboBox;
const InputTextControl = uiCore.Control.Textfield.InputText;

class NetBoxPlatformsEditor extends CommonEditor {
    constructor(args) {
        super(args);
        if (!this._itemData.create) {
            this.rootElement.classList.add("select");
        }
    }

    _init() {
        if (!this._itemData.create) {
            const dropDownData = _.get(this._itemData, "nbPlatformOptions", []);
            this.input.setOptions(dropDownData);
        }

        super._init();
    }

    applyValue(item, state) {
        super.applyValue(item, state);
        if (item.create) {
            item.netBoxName = state;
        } else {
            item.netBoxId = state;
        }
    }

    /**
     *
     * @returns {ComboBoxControlComponent}
     * @private
     */
    _createInput() {
        // console.log(this._itemData);
        if (this._itemData.create) {
            return new InputTextControl({
                darkTheme: true,
            });
        } else {
            return new SingleComboBoxControl({
                showFilter: true,
                darkTheme: true,
                adjustWidth: true,
                allowClear: false,
            });
        }
    }

    show() {}
    hide() {}
}

module.exports = NetBoxPlatformsEditor;
